import { Color, ColorSAP, FONT_FAMILY } from "../../ontego-ui";
import { Menu, MenuItem, MenuList, Paper, styled } from '@mui/material';
import ChevronRight from '../../ontego-ui/sap_icons/ChevronRight';

const Styled = {};

Styled.MenuItem = styled(MenuItem, {
    shouldForwardProp: (prop) => prop !== 'isDestructive',
  })(({ isDestructive }) => ({
    height: 36,
    fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR,
    fontSize: 12,
    color: ColorSAP.neutral[100],
    cursor: "pointer",
    display: "flex",
    overflow: "visible",
    background: ColorSAP.neutral[0],
    "& a": {
        color: ColorSAP.neutral[100]
    },
    "&:hover": isDestructive ? {
        backgroundColor: ColorSAP.danger[50],
        color: ColorSAP.neutral[0],
        borderRadius: 4,
        "& .listItemIconRoot": {
            color: ColorSAP.neutral[0],
        }
    } : {
        backgroundColor: ColorSAP.neutral[20]
    },
    "&.Mui-disabled": {
        backgroundColor: Color.neutral[300],
        color: Color.neutral[400],
        cursor: "default",
        pointerEvents: "none",
        "& a": {
            color: Color.neutral[400]
        },
        "&:hover": {
            backgroundColor: Color.neutral[300]
        }
    },
    "&.MuiListItem-divider": {
        borderBottom: `1px solid ${Color.neutral[400]}`
    },
    '& [class*="MuiListItem-focusVisible"]': {
        background: 'transparent'
    } 
}));

Styled.ListItemIconRoot = styled("div")(() => ({
    minWidth: 0,
    marginTop: 4,
    marginRight: 8,
    color: Color.neutral[400]
}));

Styled.Text = styled("div")(() => ({
    alignItems: "center",
    display: "flex",
    background: 'transparent'
}));

Styled.ArrowHeadIcon = styled(ChevronRight)(() => ({
    position: "absolute",
    right: 0,
    paddingLeft: 10,
    color: Color.neutral[500]
}));

Styled.SubMenu = styled(Paper)(({ isOpen }) => ({
    minWidth: 200,
    borderRadius: 0,
    opacity: isOpen ? 1 : 0,
    position: "absolute",
    left: "100%",
    transform: isOpen ? "scale(1, 1) translateZ(0px)" : "scale(1.75, 0.5625)",
    transformOrigin: "top right",
    transition: `opacity 0.3ms 0ms, transform 0.3ms 0ms`,
    top: 0,
    visibility: isOpen ? "visible" : "hidden",
    boxShadow: "0px 2px 29px 0px rgba(3, 3, 3, 0.15)"
}));

Styled.SubMenuListRoot = styled(MenuList)(() => ({
    padding: 0,
    background: 'transparent'
}));

Styled.MenuRoot = styled(Menu)(() => ({
    overflow: "visible",
    borderRadius: 4,
    minWidth: 240,
    boxShadow: "0px 2px 29px 0px rgba(0, 0, 0, 0.12)",

    "& .MuiMenu-list": {
        padding: 0,
        borderRadius: 4
    }
}));

export default Styled;
